<app-common-header></app-common-header>
<div class="col-12 text-center webview">
    <img src="assets/images/logo-signup.png" class="signimg signimgg" width="100" />
</div>
<div class="outterbox pt-1">
    <div>
        <div class="webview">
            <h1 class="text-center fnt25 mt-4 semi-bold lnehgt40 recommendation">{{name}}, your Honest Recommendation is ready!</h1>
            <!-- <h2 class="text-center recommendation mb-4">Honest Recommendation</h2> -->
            <!-- <div *ngIf="recommendationObj.service_type == 'Switching Providers'" class="text-center discountsize">Your
                new
                price after a <font class="pdfclr">{{
                    recommendationObj.res_products_recommendations[0].new_tier.discount_percent }}%</font> discount
                off your recent bill!
            </div> -->
            <div class="brderbotm col-lg-7 col-sm-7 m-auto webview">
            </div>
            <div  class="text-center col-lg-5 col-md-7 col-sm-4 m-auto pt-4 pb-4 px-5">
                    <h1 class="font36 lnehgt35 font-weight-bold-calibre">If you like what you see, go ahead and sign up! Or, scroll down to compare with other plans.</h1>
                <!-- <h1 class="font36 lnehgt35 font-weight-bold-calibre"> Your new price after a <font class="pdfclr"> {{discount}}% </font>
                    discount off your recent bill!</h1> -->
            </div>
        </div>
    </div>
    <div class="initialimg mobileview">
        <h1 class="text-center mt-3 mbtp mbname userName">{{name}}'s </h1>
          <h2 class="text-center recommendation mb-0 mbhonest">Honest Recommendation</h2>
        <!-- <div *ngIf="recommendationObj.service_type == 'Switching Providers'" class="text-center discountsize">Your new
            price after a <font class="pdfclr">{{
                recommendationObj.res_products_recommendations[0].new_tier.discount_percent }}%</font> discount
            off your recent bill!
        </div> -->
        <div  class="text-center topspace pb-3 m-auto col-12">
                <h1 class="mbbill">If you like what you see, go ahead and sign up! Or, scroll down to compare.</h1>
            <!-- <h1 class="mbbill"> Your new price after a <font class="pdfclr"> {{discount}}% </font>
                discount off your recent bill!</h1> -->
        </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 text-center pt-3">
        <img src="assets/images/recommendation-success.jpg" class="col-lg-4 col-md-5 col-sm-7" width="100%">
    </div>
</div>
<!-- <div class="webview tpspaces">
    <app-footer></app-footer>
</div> -->